const TermsOfParticipation = (props) => {
  return (
    <>
      <div
        className="modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto"
        id="termsOfParticipationModal"
        tabIndex="-1"
        aria-labelledby="termsOfParticipationLabel"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-lg relative w-auto pointer-events-none overflow-hidden">
          <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current h-screen-87vh">
            <div className="modal-body relative p-12 overflow-y-scroll">
              <h4 className="text-gray-800 font-semibold text-base">
                Unilever Bizztrip Katılım Koşulları
              </h4>
              <br />
              <ol className="list-decimal text-sm">
                <li>
                  Unilever Sanayi ve Ticaret Türk A.Ş. (“Unilever”) tarafından
                  düzenlenen, Unilever BizzTrip’e katılımımla bağlantılı olarak
                  elde edilen kişisel verilerimin Unilever tarafından
                  işlenebileceğini ve adımı soyadımı, telefon numaramı,
                  elektronik posta adresimi, eğitim bilgilerim dahil olmak üzere
                  kişisel verilerimin Unilever tarafından işlenmesini,
                  Unilever’in, elde edilen bu kişisel verilerimi Unilever
                  BizzTrip’e katılımımla bağlantılı olarak kullanmasını onaylar
                  ve kabul ederim. Unilever BizzTrip’e katılımımla toplanan bu
                  kişisel verilerimin, Unilever tarafından gelecekte işe alım
                  amacıyla saklanabileceğini ve Unilever'in gelecekte ortaya
                  çıkabilecek potansiyel iş fırsatları için benimle iletişime
                  geçmesinin uygun olduğunu kabul, beyan ve taahhüt ederim.
                </li>
                <br />
                <li>
                  Unilever BizzTrip ve ilgili çevrimiçi faaliyetlere gönüllü
                  olarak katıldığımı ve bu koşulların katılımımı ve katılımımla
                  ilgili sunabileceğim materyalleri düzenleyen sözleşmeyi teşkil
                  ettiğini kabul, beyan ve taahhüt ederim.
                </li>
                <br />
                <li>
                  Kişisel verilerimin Unilever tarafından Unilever BizzTrip ve
                  ilgili sözleşmelerin uygulanması amacıyla Unilever'in iş
                  ortaklarına ve yasaların gerektirdiği şekilde kamu kurumlarına
                  açıklanmasını, kişisel verilerimin, Unilever veya 3 şahıslara
                  ait güvenli sunucularda transferini ve saklanmasını kabul,
                  beyan ve taahhüt ederim.
                </li>
                <br />
                <li>
                  Kişisel verilerimin Unilever’in meşru menfaatlerinin
                  gerektirdiği ölçüde, Unilever’in iş bağlantılarına
                  aktarılmasına onay verdiğimi kabul, beyan ve taahhüt ederim.
                </li>
                <br />
                <li>
                  Unilever'in, söz konusu kişisel verilerimi Unilever BizzTrip
                  etkinliğinin bir parçası olarak 3. kişiler ile sözleşmesel
                  ilişkiler kurabileceğini kabul, beyan ve taahhüt ederim.
                </li>
              </ol>
              <br />
              <p className="text-sm">
                Gizlilik Bildirimi: Lütfen, kişisel verilerinizin toplanması,
                kullanılması, saklanması ve ifşa edilmesiyle ilgili olan ve işbu
                belgelere atıfta bulunulan ve bir parçası haline getirilen
                bilgiler için Unilever Gizlilik Politikası'nı dikkatlice okuyun.
              </p>
              <br />
              <p className="text-sm">
                Önemli: Bu katılım koşullarını kabul etmediğiniz takdirde,
                Unilever BizzTrip’e katılmanız mümkün değildir, bu çerçevede
                ilgili dijital alanlardan çıkış yapmanız gerekmektedir.
              </p>
            </div>
            <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
              <button
                type="button"
                className="px-4 py-2 mr-2 bg-red-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-700 active:shadow-lg transition duration-150 ease-in-out"
                data-bs-dismiss="modal"
              >
                Kapat
              </button>
              <label
                htmlFor={!props.isChecked ? "termsofparticipation" : ""}
                data-bs-dismiss="modal"
                className="px-4 py-2 bg-green-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-600 hover:shadow-lg focus:bg-green-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-600 active:shadow-lg transition duration-150 ease-in-out cursor-pointer"
              >
                Onaylıyorum
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfParticipation;
